import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useReceivedOrders } from '../contexts/ReceivedOrdersContext'
import { usePermissions } from '../hooks/usePermissions'
import { PERMISSIONS } from '../lib/permissions'
import IncomingOrderRow from './IncomingOrderRow'

// Same gating as cash registry — any cashier role sees these.
const CASH_REGISTRY_PERMISSIONS = [PERMISSIONS.ORDER_CHECKOUT, PERMISSIONS.PAYMENT_CASH_CREATE]

const IncomingOrdersSheet = () => {
  const { orders, count, isSheetOpen, closeSheet, refetch } = useReceivedOrders()
  const { hasAnyPermission } = usePermissions()

  if (!hasAnyPermission(CASH_REGISTRY_PERMISSIONS)) return null

  const handleCompleted = () => {
    refetch()
  }

  return (
    <Transition show={isSheetOpen}>
      <Dialog as="div" className="relative z-50" onClose={closeSheet}>
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
              <Transition.Child
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-200"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
              >
                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                  <div className="flex h-full flex-col bg-gray-50 shadow-xl">
                    <div className="flex items-start justify-between gap-4 border-b border-gray-200 bg-white px-4 py-4 sm:px-6">
                      <div>
                        <Dialog.Title className="text-base font-semibold text-gray-900">
                          Handle in OrderLine
                        </Dialog.Title>
                        <p className="mt-1 text-sm text-gray-500">
                          {count === 0
                            ? 'Nothing to handle right now.'
                            : `${count} HubRise order${count === 1 ? '' : 's'} need to be prepared via OrderLine.`}
                        </p>
                      </div>
                      <button
                        onClick={closeSheet}
                        className="text-gray-400 hover:text-gray-600"
                        aria-label="Close"
                      >
                        <XMarkIcon className="h-6 w-6" />
                      </button>
                    </div>

                    <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6">
                      {count === 0 ? (
                        <div className="text-sm text-gray-500">
                          When a HubRise order lands that we can't fully process here, it will appear in this list.
                        </div>
                      ) : (
                        <ul className="space-y-3">
                          {orders.map((order) => (
                            <IncomingOrderRow
                              key={order.id}
                              order={order}
                              onCompleted={handleCompleted}
                            />
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default IncomingOrdersSheet
